import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  deleteKycDocument,
  fetchKycDocument,
  submitKycData,
} from "../../apis/partner";

export const useFetchKycDocument = (partnerId) => {
  return useQuery({
    queryKey: ["kyc", partnerId],
    queryFn: () => fetchKycDocument(partnerId),
    onError: (error) => {
      console.error(error);
    },
  });
};

export const useSubmitKyc = (navigate) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ partnerId, kycData }) =>
      submitKycData(partnerId, kycData),
    onSuccess: (_, { partnerId }) => {
      console.log("Submitted Successfully!");
      queryClient.refetchQueries(["kyc", partnerId]);
      navigate(-1, { replace: true });
    },
    onError: (error) => {
      console.log("KYC submission error!", error);
    },
  });
};

export const useDeleteKyc = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ partnerId, kycId }) =>
      deleteKycDocument(partnerId, kycId),
    onSuccess: (_, { partnerId, kycId }) => {
      console.log("KYC document deleted!");
      queryClient.setQueryData(["kyc", partnerId], (oldData) => {
        if (oldData) {
          return oldData.filter((doc) => doc.kyc_id !== kycId);
        }
        return oldData;
      });
    },
    onError: (error) => {
      console.error("Error deleting KYC document!", error);
    },
  });
};
